import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from 'aphrodite';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

import { grape } from 'lib/css/colors';

function ActionsMenu({ actions, disabled = false }) {
  const visibleActions = actions.filter(action => !action.hidden);

  if (!visibleActions.length) {
    return null;
  }

  return (
    <Dropdown align="end">
      <Dropdown.Toggle variant="link" className={css(styles.toggleButton)} disabled={disabled}>
        <FontAwesomeIcon icon={faEllipsisV} className={css(styles.icon)} />
      </Dropdown.Toggle>
      <Dropdown.Menu className={css(styles.menu)}>
        {visibleActions.map((action, index) => (
          <Dropdown.Item
            key={index}
            onClick={action.onClick}
            disabled={action.disabled}
            className={css(styles.menuItem, action.disabled && styles.disabledItem)}
          >
            {action.icon && <FontAwesomeIcon icon={action.icon} className={css(styles.menuIcon)} />}
            {action.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}

const styles = StyleSheet.create({
  toggleButton: {
    padding: '0.25rem 0.5rem',
    border: 'none',
    backgroundColor: 'transparent',
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    ':focus': {
      boxShadow: 'none',
    },
    ':after': {
      display: 'none',
    },
  },
  icon: {
    color: grape,
    fontSize: '1rem',
  },
  menu: {
    minWidth: '120px',
    padding: '0.25rem 0',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  },
  menuItem: {
    padding: '0.5rem 1rem',
    fontSize: '0.875rem',
  },
  menuIcon: {
    marginRight: '0.5rem',
    width: '1rem',
  },
  disabledItem: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
});

ActionsMenu.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.object,
      disabled: PropTypes.bool,
      hidden: PropTypes.bool,
    }),
  ).isRequired,
  disabled: PropTypes.bool,
};

export default ActionsMenu;
